<template>
  <div class="menu-page" :style="{ background: '#b80000' }">
    <div class="warp-menu main-width">
      <template v-for="(item, index) in matchFun.detailMenu(programId, matchInfo, isMatchEmpower)">
        <div class="col-1" :key="index" @click="onClickMenu(item.url)" :class="isActive(item.url) ? ' menu-my-bg' : ''">
          <span>{{ $t(item.title) }}</span>
          <span class="head-link-icon" :style="'border-top:15px solid #b80000'"></span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import matchFun from '@comm/utils/matchFun'
export default {
  name: 'MatchMenu',
  data() {
    return {
      matchId: this.$route.query.matchId,
      programId: Number(this.$route.query.programId),
      matchFun: matchFun,
      isMatchEmpower: 0,
    }
  },
  computed: {
    ...mapState({
      matchInfo: (state) => state.match.matchInfo,
      userInfo: (state) => state.user.userInfo,
    }),
  },
  mounted() {
    // this.getisMatchEmpower()
  },
  methods: {
    onClickMenu(val) {
      console.log('onClickMenu', val, this.matchInfo)
      if (val.indexOf('http') > -1 || val.indexOf('https') > -1) {
        let params = {
          userId: this.userInfo.id,
          matchId: this.matchId,
          programId: this.programId,
          logo: this.matchInfo.logo,
          title: this.matchInfo.title,
          grade: this.matchInfo.grade,
          mode: this.matchInfo.mode,
          joinChannel: this.matchInfo.joinChannel,
        }
        params = JSON.stringify(params)
        let URI = encodeURIComponent(params)
        window.open(val + '?params=' + URI, 'aa')
      } else {
        this.$router.push({ path: val, query: { matchId: this.matchId, programId: this.programId } })
      }
    },
    isActive(val) {
      return this.$route.path.indexOf(val) > -1
    },
    // 获取组委会权限
    async getisMatchEmpower() {
      try {
        let res = await this.$api.match.isMatchEmpower(this.matchId)
        if (res.status == 0) {
          this.isMatchEmpower = res.data
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.main-width {
  width: 1200px;
  height: 60px;
  margin-left: auto;
  margin-right: auto;
}
.menu-my-bg {
  span {
    font-size: 18px;
  }
  .head-link-icon {
    width: 0;
    height: 0;
    border-right: 15px solid transparent;
    border-left: 15px solid transparent;
    position: absolute;
    bottom: -35px;
    left: 0px;
    z-index: 500;
  }
  .menu-child {
    display: block !important;
    top: 60px;
    border-radius: 4px;
    position: absolute;
    .menu-row {
      cursor: pointer;
      &:hover {
        background-color: rgba(255, 255, 255, 0.1) !important;
      }
      padding: 5px 12px;
    }
  }
}
.menu-page {
  color: #fff;
  height: 60px;
  font-size: 14px;
  .warp-menu {
    display: flex;
    align-items: center;
    .menu-child {
      display: none;
    }
    .col-1 {
      position: relative;
      padding-right: 40px;
      cursor: pointer;
      span {
        padding: 5px 0;
      }
      &:hover {
        color: #f4e2be;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/comm/components/MatchMenu.vue